/* ==== CONFIG FIREBASE ==== */
const firebaseConfig = {
  apiKey: "AIzaSyAqVca3OVfQ9ClXCrcuNKqU3Afj-p_0ntc",
  authDomain: "king-fruit-slot.firebaseapp.com",
  databaseURL: "https://king-fruit-slot.firebaseio.com",
  projectId: "king-fruit-slot",
  storageBucket: "king-fruit-slot.appspot.com",
  messagingSenderId: "883685425114",
  appId: "1:883685425114:web:cf2524285992e54a4b0ae3",
  measurementId: "G-PKPH1S7TXS"

};

/* ==== INIT FIREBASE ==== */
firebase.initializeApp(firebaseConfig);
const db = firebase.database();
console.log("🔥 Firebase tracking (manual) started");
function getDomainDV() {
  return window.location.hostname.replace(/\./g, "DV"); // netuvous.com => netuvousDVcom
}
function logToFirebase(eventType, data = {}) {
  const payload = {
    event: eventType,
    page: window.location.pathname,
    timestamp: new Date().toISOString(),
    shop: window.Shopify && Shopify.shop ? Shopify.shop : window.location.hostname,
    ...data
  };
  firebase.database().ref('shopify_events').push(payload);
  console.log("📡 Logged to Firebase:", payload);
}




/* ======= TRACK EVENTS MANUALLY ======= */


function getTodayKeyUTCMinus7() {
   const now = new Date();
  // getTimezoneOffset() trả về phút lệch so với UTC (ở VN là -420)
  // ta cần lùi thêm 7h nữa ⇒ cộng (offset - 420)
  const utcMinus7 = new Date(now.getTime() + (now.getTimezoneOffset() - 420) * 60000);

  const month = utcMinus7.getMonth() + 1;
  const day = utcMinus7.getDate();
  const year = utcMinus7.getFullYear();

  const key = `${month}-${day}-${year}`;
  console.log("🕒 Local time:", now.toString());
  console.log("🕒 UTC-7 time:", utcMinus7.toString());
  console.log("📅 Today key (UTC-7):", key);
  return key;
}



/* ====== UTIL ====== */
function getTodayKey() {
  const d = new Date();
  return `${d.getMonth() + 1}-${d.getDate()}-${d.getFullYear()}`;
}
function getDeviceType() {
  return /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent) ? "Mobile" : "PC";
}

async function getUserIP() {
  try {
    const res = await fetch("https://api.ipify.org?format=json");
    const data = await res.json();
    return data.ip || "0.0.0.0";
  } catch {
    return "0.0.0.0";
  }
}

/* ====== MAIN TRACKING ====== */
document.addEventListener("DOMContentLoaded", async () => {
  if (!window.location.pathname.includes("/products/")) return;
setTimeout(attachCheckoutListener, 5000); // thử attach sau 4 giây
  // ✅ Dữ liệu sản phẩm chuẩn từ Shopify Liquid
const productId = window.PRODUCT_DATA && window.PRODUCT_DATA.id;
const productName = window.PRODUCT_DATA && window.PRODUCT_DATA.title;
const productImg = window.PRODUCT_DATA && window.PRODUCT_DATA.image;
const productLink = window.PRODUCT_DATA && window.PRODUCT_DATA.link;

  if (!productId) {
    console.warn("⚠️ Không tìm thấy product.id – chỉ chạy ở trang sản phẩm.");
    return;
  }


  async function shortHash(input) {
  const data = new TextEncoder().encode(input);
  const hash = await crypto.subtle.digest("SHA-1", data);
  return Array.from(new Uint8Array(hash))
    .map(b => b.toString(16).padStart(2, "0"))
    .join("")
    .slice(0, 8);
}

  

  const today = getTodayKeyUTCMinus7();
  const device = getDeviceType();
  const ip = await getUserIP();
  const ipHash = await shortHash(ip + navigator.userAgent);
  const ipKey = ip.replace(/\./g, "DV") +"DV"+ ipHash;
  const domainNode = getDomainDV();
  console.log(domainNode)

  const productRef = db.ref(`${domainNode}/PUB/${today}/${productId}`);
  const productRef2 = db.ref(`${domainNode}/PUB2/${today}/${productId}`);

  // 🧠 Ghi thông tin sản phẩm (nếu chưa có)
  productRef.once("value").then((snap) => {
    if (!snap.exists()) {
      productRef.set({
        LK: productLink,
        NAME: productName,
        TB: productImg,
        VC: {}
      });
      productRef2.set({
        LK: productLink,
        NAME: productName,
        TB: productImg,
        VC: {}
      });
    } else {
      // Nếu đã tồn tại, chỉ cập nhật lại thông tin để đảm bảo luôn đúng
      productRef.update({
        LK: productLink,
        NAME: productName,
        TB: productImg
      });
      productRef2.update({
        LK: productLink,
        NAME: productName,
        TB: productImg
      });
    }


    const ua = navigator.userAgent.toLowerCase();
    const isBot = /(bot|crawler|spider|crawling|preview|facebookexternalhit)/i.test(ua);

    // 🔹 Ghi viewer (IP + thiết bị)
    db.ref(`${domainNode}/PUB/${today}/${productId}/VC/${ipKey}`).set(navigator.userAgent);
    if(!isBot)
    {
        db.ref(`${domainNode}/PUB2/${today}/${productId}/VC/${ipKey}`).set(device);
    }

    console.log(`✅ Logged ViewContent → ${productId}`);
    console.log(`📄 ${productName} | ${navigator.userAgent} | ${ip}`);
  });



  /* ====== 2️⃣ ADD TO CART ====== */
  document.addEventListener("click", (e) => {
    if (e.target.closest('button[name="add"]')) {
      const atcRef = db.ref(`${domainNode}/PUB/${today}/${productId}/ATC/${ipKey}`);
      atcRef.set(navigator.userAgent);

      const atcRef2 = db.ref(`${domainNode}/PUB2/${today}/${productId}/ATC/${ipKey}`);
      atcRef2.set(true);

      console.log(`🛒 Add To Cart → ${productId}`);
    }
  });

  


  console.log("✅ Bootstrap OK 1. productId:", productId);

  
  /* ====== 3️⃣ CHECKOUT STARTED ====== */
  /* ====== PAYPAL CHECKOUT START (khi click trong container PayPal) ====== */
// let paypalStartAttached = false;

// function attachPaypalStart(){
//   if (paypalStartAttached) return;

//   // 👉 Selector chính xác theo DOM thực tế
//   const cand = document.querySelector('[id^="zoid-paypal-buttons-uid_"]');
//   if (!cand) {
//     console.log("⚠️ PayPal container not found yet, retrying...");
//     return;
//   }

//   paypalStartAttached = true;
//   cand.style.outline = '2px dashed #0aa'; // dễ nhận biết
//   console.log("✅ Found PayPal container:", cand);

//   document.querySelector('.shopify-payment-button').addEventListener('click', async () => {
//     const today = getTodayKeyUTCMinus7();
//     const device = getDeviceType();
//     const ip = await getUserIP();
//     const ipHash = await shortHash(ip + navigator.userAgent);
//     const ipKey = ip.replace(/\./g, "DV") + "DV" + ipHash;
//     const domainNode = getDomainDV();

//     await db.ref(`${domainNode}/PUB/${today}/${productId}/CO/${ipKey}`).set(navigator.userAgent);
//     await db.ref(`${domainNode}/PUB2/${today}/${productId}/CO1/${ipKey}`).set(device);
//     console.log("💳 Checkout Start logged:", productId, ipKey);
//   }, { capture: true });
// }



/* ====== BOOT ====== */
// 0) xác nhận script chạy
console.log("✅ Bootstrap OK. productId:", productId);

// 1) Gắn ATC ngay
//attachATC();


/* ====== 3️⃣ CHECKOUT STARTED (NORMAL SHOPIFY BUTTON) ====== */ 
function attachCheckoutListener() {
  const checkoutBtn = document.querySelector(
    '#CartDrawer-Checkout, button[name="checkout"], .cart-checkout-button'
  );

  if (!checkoutBtn) {
    console.log("❌ No checkout button found yet");
    return;
  }

  console.log("✅ Checkout button FOUND:", checkoutBtn);

  checkoutBtn.addEventListener("click", async (e) => {
    e.preventDefault();

    try {
      const today = getTodayKeyUTCMinus7();
      const device = getDeviceType();
      const ip = await getUserIP();
      const ipHash = await shortHash(ip + navigator.userAgent);
      const ipKey = ip.replace(/\./g, "DV") + "DV" + ipHash;
      const domainNode = getDomainDV();
      const productId = window.PRODUCT_DATA && window.PRODUCT_DATA.id;

      if (productId) {
        await db.ref(`${domainNode}/PUB/${today}/${productId}/CO/${ipKey}`).set(navigator.userAgent);
        await db.ref(`${domainNode}/PUB2/${today}/${productId}/CO5/${ipKey}`).set(device);

        console.log("💳 Checkout logged:", productId);
      }
    } catch (err) {
      console.error("❌ Checkout log error:", err);
    }

    // SUBMIT FORM CHUẨN CỦA DAWN
    const form = checkoutBtn.closest("form");
    if (form) form.submit();
    else window.location.href = "/checkout";
  });
}

// chạy lần đầu
attachCheckoutListener();

// chạy lại mỗi khi cart drawer thay đổi
document.addEventListener("cart:updated", attachCheckoutListener);
document.addEventListener("shopify:section:load", attachCheckoutListener);



// // 2) Chờ PayPal container xuất hiện (Dawn ajax / lazy render)
// const mo = new MutationObserver(() => {
//   console.log("👀 DOM updatedddd, checking for PayPal button...");
//   attachPaypalStart();
// });
// mo.observe(document.body, { childList: true, subtree: true });
// // gọi thử lần đầu
// attachPaypalStart();
// // ====== LISTEN TO PAYPAL MESSAGE ======
// window.addEventListener("message", async (event) => {
//   if (!event.data || typeof event.data !== "object") return;

//   // PayPal SDK gửi message dạng { event: "click", ... } hoặc { source: "paypal-buttons" ... }
//   if (event.data.event === "click" || event.data.source === "paypal-buttons") {
//     const today = getTodayKeyUTCMinus7();
//     const device = getDeviceType();
//     const ip = await getUserIP();
//     const ipHash = await shortHash(ip + navigator.userAgent);
//     const ipKey = ip.replace(/\./g, "DV") + "DV" + ipHash;
//     const domainNode = getDomainDV();

//     await db.ref(`${domainNode}/PUB/${today}/${productId}/CO/${ipKey}`).set(navigator.userAgent);

//     console.log("💳 PayPal iframe click detected and logged:", productId, ipKey);
//   }
// });

// // 3) Re-attach khi Section load (Shopify OS2.0)
// document.addEventListener("shopify:section:load", attachPaypalStart);



});

/* ===== TRACK CHECKOUT START ===== */



// window.logClickPayPalDomain = async function(productID) {
//   try {
//     const today = getTodayKeyUTCMinus7();
//     const device = getDeviceType();
//     const ip = await getUserIP();
//     const ipHash = await crypto.subtle.digest("SHA-1", new TextEncoder().encode(ip + navigator.userAgent))
//       .then(buf => Array.from(new Uint8Array(buf)).map(b => b.toString(16).padStart(2, "0")).join("").slice(0, 8));
//     const ipKey = ip.replace(/\./g, "DV") + "DV" + ipHash;
//     const domainNode = getDomainDV();

//     firebase.database().ref(`${domainNode}/PUB/${today}/${productID}/PAYPAL/${ipKey}`).set(navigator.userAgent);
//     firebase.database().ref(`${domainNode}/PUB2/${today}/${productID}/CO5/${ipKey}`).set(device);

//     console.log(`🛒 CheckOut → ${productID}`);
//   } catch (err) {
//     console.error("❌ Error in logClickPayPalDomain:", err);
//   }
// };

